import { Row } from './AuthFormLayout.styled'

type AuthFormLayoutProps = {
  children: Array<React.ReactNode>
}

const AuthFormLayout: React.FC<AuthFormLayoutProps> = ({ children }) => {
  return (
    <>
      {children.map((item: any, index: number) => {
        if (!item) return null
        return <Row key={index}>{item}</Row>
      })}
    </>
  )
}

export default AuthFormLayout
